export default "__VITE_ASSET__BrYYJIc7__"